<template>
    <div class="b-menu-main-bubble" :class="classes" :style="[backgroundColor, size]">

      <div class="b-menu-main-bubble__content">
        <transition name="fade" mode="out-in">
          <!-- Slot content -->
          <slot v-if="showSlotContent"></slot>

          <!-- Content component -->
          <component v-if="showComponentContent" :is="mainBubbleContentComponent"
                     :parent="parent"
                     :activeChild="StoreHelper.getActiveChild()"
                     :hover="StoreHelper.isHoverInProgress()"
                     :edit="StoreHelper.isEditInProgress()">
          </component>

          <!-- Default content -->
          <div v-if="showDefaultContent" class="b-menu-main-bubble__content-default">{{ parent.title }}</div>
        </transition>
      </div>

    </div>
</template>

<script>
import StoreHelper from '../store/helper'

import _ from 'lodash'

export default {
  name: 'b-menu-main-bubble',
  props: {
    parent: {
      type: Object
    }
  },
  data () {
    return {
      StoreHelper,
      mainBubbleContentComponent: StoreHelper.getMainBubbleContentComponent()
    }
  },
  computed: {
    classes () {
      return {
        'b-menu-main-bubble--slot-content': this.showSlotContent,
        'b-menu-main-bubble--component-content': this.showComponentContent,
        'b-menu-main-bubble--default-content': this.showDefaultContent,
        'b-menu-main-bubble--hover-mode': StoreHelper.isHoverInProgress(),
        'b-menu-main-bubble--edit-mode': StoreHelper.isEditInProgress()
      }
    },
    size () {
      return { width: `${StoreHelper.getMenuMainBubbleSize()}px`, height: `${StoreHelper.getMenuMainBubbleSize()}px` }
    },
    hasSlotContent () {
      return !_.isUndefined(this.$slots.default)
    },

    showSlotContent () {
      return this.hasSlotContent && !StoreHelper.isHoverInProgress() && !StoreHelper.isEditInProgress()
    },

    hasComponentContent () {
      return !_.isNull(this.mainBubbleContentComponent)
    },

    showComponentContent () {
      return !this.showSlotContent && this.hasComponentContent
    },

    showDefaultContent () {
      return !this.showSlotContent && !this.showComponentContent
    },

    backgroundColor () {
      const item = StoreHelper.getActiveChild() || this.parent

      return {
        backgroundColor: item && item.colorDefinition ? item.colorDefinition.hex : null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.b-menu-main-bubble {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  border-radius: 50%;

  padding: 20px;
  z-index: 2;
  transition: background-color 500ms ease;

  &__content {
    height: 100%;
    padding: 10%;
  }

  &__content-default {
    color: white;
    font-weight: bold;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 100ms;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
